import { computed, ElementRef, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  active_modals_ref = signal<ElementRef[]>([]);
  count = computed(() => this.active_modals_ref().length);

  isSecurityCheckActive = signal(false);

  attach(el: ElementRef) {
    this.active_modals_ref.update((modals) => [...modals, el]);
  }
  detach(el: ElementRef) {
    this.active_modals_ref.update((modals) => modals.filter((m) => m !== el));
  }

  isClosable(requested_modal?: ElementRef): boolean {
    if (this.count() > 1 && requested_modal) {
      // If there are multiple modals, we only allow closing the topmost one
      const topmostModal = this.active_modals_ref()[this.count() - 1];
      return topmostModal === requested_modal;
    }
    return this.count() > 0 && !this.isSecurityCheckActive();
  }
}
